import axios from 'axios';
import {
  IImportEmployeeAddViewModel,
  IImportEmployeeAddListViewModel,
} from '../Converts/ICloudFactoryInterfaces';
import { ICloudFactoryProductsViewModel } from '../Converts/CludFactoryConfig';
import { ICompanyAddViewModel } from 'Interfaces/ICompaniesConfig';

const cloudFactoryAPI = axios.create({
  baseURL: 'https://portal.api.cloudfactory.dk',
  timeout: 50000,
  headers: { 'Content-Type': 'application/json' },
});

export const CloudFactoryService = {
  // Bytt refresh-token mot tilgangstoken
  exchangeToken: (refreshToken: string) =>
    cloudFactoryAPI.get<{ access_token: string }>(
      `/Authenticate/ExchangeRefreshToken/${refreshToken}`
    ),
  // Hent liste av selskaper fra CloudFactory
  getCompanies: (
    pageIndex: number,
    pageSize: number,
    token: string
  ) =>
    cloudFactoryAPI.get<{
      metadata: {
        page: number;
        pageSize: number;
        totalPages: number;
        totalRecords: number;
      };
      customers: any[];
    }>(
      `/v2/customers/Customers`,
      {
        params: { PageIndex: pageIndex, PageSize: pageSize },
        headers: { Authorization: `Bearer ${token}` },
      }
    ),

  // Hent ansatte for ett selskap
  getEmployees: (legacyCustomerId: string, token: string) =>
    cloudFactoryAPI.get<any[]>(
      `/v2/microsoft/customer/${legacyCustomerId}/users`,
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  // Hent enkelt ansattes lisenser
  getEmployeeLicenses: (
    legacyCustomerId: string,
    employeeId: string,
    token: string
  ) =>
    cloudFactoryAPI.get<any[]>(
      `/v2/microsoft/customer/${legacyCustomerId}/users/${employeeId}/licenses`,
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  // Hent aktive abonnement/produkter for ett selskap
  getSubscriptions: (legacyCustomerId: string, token: string) =>
    cloudFactoryAPI.get<any[]>(
      `/v2/microsoft/customer/${legacyCustomerId}/subscriptions`,
      {
        params: { Statuses: 'Active' },
        headers: { Authorization: `Bearer ${token}` },
      }
    ),

  // Hent detaljert produktinfo fra katalogen
  getCatalogueProducts: (
    legacyCustomerId: string,
    sku: string,
    billingCycle: 'Monthly' | 'Annually',
    termDuration: 'P1M' | 'P1Y',
    pageIndex: number,
    pageSize: number,
    token: string
  ) => {
    const params = {
      'Filter.CategoryIds': 'db584fbc-8a3a-4c68-b486-d9c8764dc10e',
      'Filter.SKUs': sku,
      'Filter.BillingCycles': billingCycle === 'Monthly' ? '1' : '12',
      'Filter.CommitmentLengths': termDuration === 'P1Y' ? '12' : '1',
      PageIndex: pageIndex,
      PageSize: pageSize,
      FilterName: sku,
    };
    return cloudFactoryAPI.get<any>(
      `/v2/catalogue/products`,
      {
        params,
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  
  // Sammenlign produkter mot eget backend-API
  fetchCompareCompanies: (payload: {
    numberOfCompanies: number;
    cloudFactoryCompanies: ICompanyAddViewModel[];
  }) =>
    axios.post<ICompanyAddViewModel[]>(
      `${process.env.API_URL}/Module/CloudFactory/ComparedCompanies`,
      payload
    ),


  // Sammenlign produkter mot eget backend-API
  fetchCompareProducts: (payload: {
    cloudFactoryProducts: ICloudFactoryProductsViewModel[];
  }) =>
    axios.post<IImportEmployeeAddListViewModel>(
      `${process.env.API_URL}/Module/CloudFactory/GetCloudFactoryComparedProducts`,
      payload
    ),

  // Sammenlign ansatte mot eget backend-API
  fetchCompareEmployees: (payload: {
    NumberOfCloudFactoryEmployees: number;
    cloudFactoryEmployees: IImportEmployeeAddViewModel[];
  }) =>
    axios.post<IImportEmployeeAddListViewModel>(
      `${process.env.API_URL}/Module/CloudFactory/GetCloudFactoryComparedEmployees`,
      payload
    ),
};
